import { Injectable } from '@angular/core';

import { Consorcio } from '../model/Consorcio';
import { Sucursal } from '../model/sucursal';
import { DocumentoEntrada } from '../model/documento-entrada';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service'
import { Resultado } from 'app/model/resultado';


@Injectable()
export class DocumentoEntradaService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  getDocumentos(codigoConsorcio: string, codigoSucursal: string): Observable<DocumentoEntrada[]> {

    const requestUrl = this._utilities.getURLIIS('DocumentoEntrada/entrada/'
    + codigoConsorcio + '/' + codigoSucursal);

  return this._http.get(requestUrl).map((response: Response) => {
    return <DocumentoEntrada[]>response.json();
  });

  }

  public insert(documento: DocumentoEntrada) {

    let json = { "Metodo": "postDocumentoEntrada", "Datos": documento };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

  //  public aprobar(query: any){

  //     let json = {   "Metodo": "aprobarDocumentoEntrada",   "Datos": query  };

  //     let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
  // 		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});


  // 		return this._http.post(this._utilities.getURL("post"), 
  // 				params, {headers: headers}).map(res => res.json());
  // }


  public aprobar(idAlmacen: string, idCompania: string, idSucursal: string, idDocumento: string): Observable<Resultado> {

    const requestUrl = this._utilities.getURLIIS('DocumentoEntrada/aprobarDocumento/'
      + idAlmacen + '/' + idCompania + '/' + idSucursal + '/' + idDocumento);

    return this._http.get(requestUrl).map((response: Response) => {
      return <Resultado>response.json();
    });
  }

  public actualizar(query: any) {

    let json = { "Metodo": "actualizarDocumentoEntrada", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

  public delete(documento: DocumentoEntrada) {

    let json = { "Metodo": "deleteDocumentoEntrada", "Datos": documento };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/documento-entrada.service.ts